import axios from "axios";
import { defineStore } from "pinia";
import { useConversation } from "./Conversation";
import DateUtilities from "../Utilities/DateUtilities";
import { useAppState } from "./AppState";
import { useUserStore } from "./User";
import {
    getActivityChinUsersSnapshot,
    resolveActivityChinUsers,
} from "../Components/Activity/activityChinUsers";
import {
    filterActivityConversations,
    filterActivityConversationsByTypes,
    filterActivityConversationsWithUser,
} from "../Helpers/activityFilterConversations";

export const useActivity = defineStore("ActivityStore", {
    state: () => ({
        selected_list: "",
        hovered_list: "",
        profile_ids_conversed_within_selected_days: [],
        filters: {
            profile_ids: [],
            space_id: null,
            board_id: null,
            days: null,
            conversation_types: [],
        },
        selected_activity: null,
        selected_activity_chin_users: [],
        documentDetails: {
            open: false,
            conv_id: undefined,
        },
    }),
    getters: {},
    actions: {
        setSelectedList(value) {
            if (!value) return;

            this.selected_list = value;
        },
        setHoveredList(value) {
            if (!value) return;

            this.hovered_list = value;
        },
        setSelectedUserIds(val) {
            this.filters.profile_ids = Array.isArray(val) ? val : [];
        },
        toggleSelectedUserId(val) {
            if (val == null) {
                return;
            }

            const profile_ids = [...this.filters.profile_ids];
            const index = profile_ids.indexOf(val);

            if (index >= 0) {
                profile_ids.splice(index, 1);
            } else {
                profile_ids.push(val);
            }

            this.filters.profile_ids = profile_ids;
        },
        setSelectedSpaceId(val) {
            this.filters.space_id = val;
        },
        setSelectedBoardId(val) {
            this.filters.board_id = val;
        },
        setSelectedDays(val) {
            this.filters.days = val;
            this.prepareProfilesConversedWithinSelectedDays();
        },
        setSelectedConversationType(val) {
            this.filters.conversation_types = val;
        },
        prepareProfilesConversedWithinSelectedDays() {
            const profiles_conversed_within_selected_days = new Set();

            let conversations = useConversation().handlers;
            if (this.filters.days) {
                conversations = conversations.filter((conv) => {
                    const last_message_date =
                        conv?.getTwilioConversation()?.lastMessage?.dateCreated;
                    return last_message_date
                        ? DateUtilities.getDifferenceInDays(
                              last_message_date,
                              new Date(),
                          ) <= this.filters.days
                        : "";
                });
            }

            const conv_profiles_ids = conversations
                .filter((conv) => !conv.isGroup())
                .map((conv) => conv.getActiveParticipantIds());

            const userStore = useUserStore();

            conv_profiles_ids?.forEach((conv) => {
                const sort_latest_profile = conv.reverse();
                sort_latest_profile.forEach((user_id) => {
                    const profile = userStore.getUserProfileById(user_id);

                    if (profile?.is_agent) {
                        const actualUserProfile =
                            userStore.getAgentUserProfileByAgentId(user_id);
                        if (
                            actualUserProfile?.id ===
                            userStore?.user_data.support_admin?.id
                        )
                            return;
                    }

                    return profiles_conversed_within_selected_days.add(user_id);
                });
            });

            this.profile_ids_conversed_within_selected_days =
                profiles_conversed_within_selected_days;
        },
        filterConversations() {
            return filterActivityConversations(
                useConversation().handlers,
                this.filters,
            );
        },
        filterConversationsWithLastMessageInDays(conversations) {
            conversations = conversations.filter((item) => {
                const last_message_date =
                    item?.getTwilioConversation()?.lastMessage?.dateCreated;
                return last_message_date
                    ? DateUtilities.getDifferenceInDays(
                          last_message_date,
                          new Date(),
                      ) <= this.filters.days
                    : "";
            });
            return conversations;
        },

        filterConversationsWithUser(conversations) {
            return filterActivityConversationsWithUser(
                conversations,
                this.filters,
            );
        },

        filterConversationsByTypes(conversations) {
            return filterActivityConversationsByTypes(
                conversations,
                this.filters,
            );
        },

        setSelectedActivity(val) {
            // if (val.id === this.selected_activity?.id)
            //     this.selected_activity = null
            // else
            this.selected_activity = val;
            this.selected_activity_chin_users = getActivityChinUsersSnapshot(val);
            void this.syncSelectedActivityChinUsers();
        },

        async syncSelectedActivityChinUsers() {
            const activity = this.selected_activity;
            const activity_id = activity?.id;

            if (!activity) {
                this.selected_activity_chin_users = [];
                return;
            }

            const users = await resolveActivityChinUsers(activity);

            if (this.selected_activity?.id === activity_id) {
                this.selected_activity_chin_users = users;
            }
        },

        toggleDocument(show = false, convId = undefined) {
            this.documentDetails = {
                open: show,
                conv_id: show ? convId : undefined,
            };
            if (show) {
                useAppState().openDocumentInActivity();
            } else {
                useAppState().closeDocumentInActivity();
            }
        },
        handleInvitationApiForItems() {
            void this.syncSelectedActivityChinUsers();
        },
        updateSelectedActivityName(item) {
            if (!this.selected_activity) return;

            if (
                this.selected_activity.is_item &&
                this.selected_activity.originalData?.item?.id === item.id
            ) {
                this.selected_activity.originalData.item.name = item.name;
                this.selected_activity.name = item.name;
            }
        },
    },
});
